import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  from { opacity: 0 }\n  to { opacity: 1 }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n        animation: ",
        " 1s;\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Center } from "@chakra-ui/react";
import { css, keyframes } from "@emotion/react";
import Spinner from "@inspire/ui/chakra/Spinner";
import DeferredLoading from "@inspire/ui/general/DeferredLoading";
var animation = keyframes(_templateObject());
var PageSpinner = function() {
    return /*#__PURE__*/ _jsx(DeferredLoading, {
        children: /*#__PURE__*/ _jsx(Center, {
            css: css(_templateObject1(), animation),
            minH: 150,
            children: /*#__PURE__*/ _jsx(Spinner, {
                size: "xl",
                thickness: "4px"
            })
        })
    });
};
export default PageSpinner;
